import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import GooglePlay from './googleplay.png';
import AppStore  from './appstore.png';
import ApprovalSeal  from './approval.png';
import EN from './lang/en.png';
import VI from './lang/vi.png';
import fb from './social/fb.png';
import ig from './social/ig.png';
import tw from './social/tw.png';
import ln from './social/ln.png';
import wc from './social/wc.png';
import wk from './social/wk.png';
import winglet from './vietjet-winglet.png';
import { ReactComponent as Logo } from './logo.svg';
import { ReactComponent as CloseSVG } from './close.svg';
import { ReactComponent as LoadSVG } from './loader.svg';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col, Navbar, Nav, NavDropdown, Modal } from 'react-bootstrap';

export const MessageModal = (props) => {
	return (
		<Modal
			show={props.show}
			onHide={props.onHide}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			backdrop={props.allowClose ? true : 'static'}
			keyboard={props.allowClose ? true : false}
		>
			<Modal.Header>
				<Container>
				<Row>
					<Col>
						<Modal.Title id="contained-modal-title-vcenter">{props.headerLabel}</Modal.Title>
					</Col>
					<Col xs={4} className={'text-sm-right'}>
					{props.allowClose ? (<CloseSVG onClick={props.onHide} style={{cursor:'pointer'}}/> ) : (<LoadSVG />)}
					</Col>
				</Row>
				</Container>
			</Modal.Header>
			<Modal.Body>
			<Container>
				<Row className={'mb-5'}>
					<Col>
					{props.bodyMessage}
					</Col>
				</Row>
				</Container>
			</Modal.Body>
			{props.allowClose && (<Modal.Footer>
			<button onClick={props.onHide} className="btn">{props.closeLabel}</button>
			</Modal.Footer>)}
		</Modal>
	);
}

export const SuccessState = (props) => {
	const { t,lang } = props;
	return (
		<Container>
			<Row className="mt-3 mb-5 justify-content-left">
				<Col className={'text-left'}>
					<h1 className="mt-5">{t('sections.success.title')}</h1>
				</Col>
			</Row>
			<Row className="mt-3 mb-5 justify-content-left">
				<Col className={'text-left'}>{t('sections.success.description')}</Col>
			</Row>

			<Row className="mt-3 mb-1 justify-content-left">
				<Container>
					<Row className="mt-3 mb-1 justify-content-left">
					<Col sm={{ span: 12 }} md={{ span: 8 }}>
								
								<Row className="mt-3 mb-1 justify-content-left">
									<h2 className="">{t('sections.success.accountTitle')}</h2>
								</Row>
								<Row className="mt-3 mb-5 justify-content-left recap">
									<Col className={'text-left'}>
										<Row className={'mb-3 mb-sm-1'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.pass.type')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>POWERPASS {props.passType}</Col>
										</Row>
										<Row className={'mb-3 mb-sm-1'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.pass.passenger')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.traveler}</Col>
										</Row>
										<Row className={'mb-3 mb-sm-1'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.pass.username')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.userLogonName}</Col>
										</Row>
										<Row>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.pass.serial')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.serialNumber}</Col>
										</Row>
									</Col>
								</Row>
							</Col> 

							<Col sm={{ span: 12 }} md={{ span: 8 }}>
								<Row className="mt-3 mb-1 justify-content-left">
										<h2 className="">{t('sections.success.paymentTitle')}</h2>
								</Row>
								<Row className="mt-3 mb-5 justify-content-left recap">
									<Col className={'text-left'}>
									
									{props.discountTotal != "0" && ( 
										 <>
										<Row className={'mb-3 mb-sm-1'}>
										 <Col sm={7} className={'text-left detail'}>
											{t('sections.success.payment.originalPrice')} - {props.passType.id}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.originalTotal} VND</Col>
										</Row>
										<Row className={'mb-3 mb-sm-1 discounted'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.payment.discountedAmount')} - {props.discount.id} - {props.discount.percentage}%
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>({props.discountTotal} VND)</Col>
										</Row>
										</>
										)}
										<Row className={'mb-3 mb-sm-1'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.payment.subTotal')} - {props.passType.id}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.subTotal} VND</Col>
										</Row>
										<Row className={'mb-3 mb-sm-1'}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.payment.taxTotal')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.taxesTotal} VND</Col>
										</Row>
										<Row className={`mb-3 mb-sm-1 ${(props.discountCode)?'discounted':''}`}>
											<Col sm={7} className={'text-left detail'}>
											{t('sections.success.payment.total')}
											</Col>
											<Col sm={5} md={5} className={'text-sm-right'}>{props.paymentTotal} VND</Col>
										</Row>
										
										{props.discountTotal != "0" && (<Row className={'mb-3 mb-sm-1 mt-4'}>
											<Col className={'text-left detail'}>
											<h2>{t('sections.success.discountConfirmation', {percent: props.discount.percentage})}</h2>
											</Col>
										</Row>)}

									</Col>
								</Row>
							
							</Col>

						
					</Row>
					</Container>

			</Row>
			<Row className="mt-3 mb-5 justify-content-left">
						<Col sm={6}>
							<Row>
						<Col className={'text-left'}>
							<a href={`${process.env.REACT_APP_IBE_URL}?lang=${lang}`} className={'btn btn-submit'}>
								{t('sections.success.button.label')}
							</a>
						</Col>
						<Col className={'text-left'}>
							<a href={`/${lang}`}
								className="btn btn-grey"
							>
								{t('sections.success.registerAgain.label')}
							</a>
						</Col>
						</Row>
						</Col>
					</Row>
					

		</Container>
	);
}


export const PageHeader = props => {
	const { handleClickSelectLanguage, t } = props;
	const handleSelect = (eventKey) => handleClickSelectLanguage(eventKey);

return (<Navbar expand="lg" variant="dark">
	<Container>
  <Navbar.Brand><Logo /></Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav" className="flex-column ml-auto">
    <Nav className="ml-auto navbar-right navbar-nav" onSelect={handleSelect}>
      <NavDropdown title={
                    <>
                        <img 
                            src={(props.lang == "en") ? EN : VI} 
                        />
                        <span>{(props.lang == "en") ? 'English' : 'Tiếng Việt'}</span>
                    </>
                } id="basic-nav-dropdown" alignRight>
									<NavDropdown.Item eventKey="vi" href="/vi" onClick={(e)=> {e.preventDefault();}}><img src={VI} /><span>Tiếng Việt</span></NavDropdown.Item>
        						<NavDropdown.Divider />
									<NavDropdown.Item eventKey="en" href="/en" onClick={(e)=> {e.preventDefault();}}><img src={EN} /><span>English</span></NavDropdown.Item>
      </NavDropdown>
    </Nav>
	{/* 	<Nav className="ml-auto navbar-right navbar-nav">
			<NavLink
						className="nav-link"
						to={`intro`}
						activeStyle={{
					}}>
							
							{t('nav.links.intro')}
					</NavLink>
			<NavLink
						className="nav-link"
						to={`buy`}
						activeStyle={{
					}}>
						{t('nav.links.buy')}
					</NavLink>
      <Nav.Link href={process.env.REACT_APP_IBE_URL}>{t('nav.links.book')}</Nav.Link>
					<NavLink
						className="nav-link"
						to={`contact`}
						activeStyle={{
					}}>
							{t('nav.links.contact')}
					</NavLink>
    </Nav>
   */}
	</Navbar.Collapse>
	</Container>
</Navbar>)
};

export const PageFooter = props => {
	
	const {  t } = props;

	return (<div className="footer-container">
<div className="footer-child">
<Container className="footer">
			<Row className="mt-3 mb-5 justify-content-start">
				<Col xs={12} md={4} className={'text-left'}>
					<h3 className="mb-3">{t('sections.footer.social.title')}</h3>
					<div className="social">
						<a href="https://www.facebook.com/vietjetvietnam"><img src={fb}/></a>
						<a href="https://www.instagram.com/vietjet/"><img src={ig}/></a>
						<a href="https://twitter.com/vietjetvietnam"><img src={tw}/></a>
						<a href="#"><img src={ln}/></a>
						<a href="#"><img src={wc}/></a>
						<a href="#"><img src={wk}/></a>
					</div>
				</Col>
				<Col xs={12} md={4} className={'text-left'}>
				<h3 className="mb-3">{t('sections.footer.app.title')}</h3>
					<div className="apps">
						<a href="https://apps.apple.com/vn/app/vietjet-air/id867009161#?platform=iphone"><img src={AppStore} /></a>
						
						<a href="https://play.google.com/store/apps/details?id=com.vietjetair.vjmobileapp&hl=vi"><img src={GooglePlay} /></a>
					</div>
				</Col>
				<Col xs={12} md={4} className={'text-left'}>
				<h3 className="mb-3">{t('sections.footer.company.title')}</h3>
				{t('sections.footer.company.address')}
				<img src={ApprovalSeal} />
				</Col>
			</Row>
</Container>
<img width="137" height="243" src={winglet} />
</div>
</div>)
}
;
/* export const PageFooter = props =>
<> { ReactHtmlParser (`<footer>Page footer</footer>`) 
} </>
; */

export const TandC = props => {
	if(props.lang == "vi"){
return (<> { ReactHtmlParser (`<div>
<h1>Điều khoản v&agrave; điều kiện &aacute;p dụng của <strong>Vietjet POWER PASS</strong></h1>
<p>Khi Quý khách chọn nhấn vào ô <strong><i>“Tôi đồng ý các điều khoản và điều kiện*”</i></strong> trong quá trình đăng ký mua Power Pass thì Quý khách đã đồng ý và chấp thuận tất cả các điều khoản và điều kiện áp dụng của Power Pass được nêu dưới đây. Đề nghị Quý khách xem kỹ trước khi chọn thanh toán!</p>
<ol>
	<li>
		<strong>Điều khoản chung</strong>
		<ol>
			<li>
				Power Pass l&agrave; phiếu thanh to&aacute;n tiền gi&aacute;
				v&eacute; m&aacute;y bay của Vietjet cho một h&agrave;nh
				kh&aacute;ch cụ thể c&oacute; t&ecirc;n v&agrave; chi tiết
				c&aacute; nh&acirc;n như đ&atilde; đăng k&yacute; trong t&agrave;i
				khoản Power Pass với Vietjet. T&ugrave;y theo loại Power Pass quy
				định về thời gian hiệu lực v&agrave; điều kiện &aacute;p dụng cụ
				thể, kh&aacute;ch h&agrave;ng (<em
					>người c&oacute; t&ecirc;n in tr&ecirc;n Power Pass &ndash; chủ
					sở hữu; người thụ hưởng</em
				>) được mua v&agrave; bay kh&ocirc;ng giới hạn tr&ecirc;n
				c&aacute;c chuyến bay nội địa Việt Nam trong thời hạn hiệu lực
				v&agrave; điều kiện &aacute;p dụng li&ecirc;n quan của loại Power
				Pass đ&oacute;.
			</li>
			<li>
				Power Pass c&oacute; thể được mua v&agrave; thanh to&aacute;n bằng
				c&aacute;c h&igrave;nh thức thanh to&aacute;n trực tuyến hợp lệ
				m&agrave; Vietjet y&ecirc;u cầu v&agrave; chấp nhận.
			</li>
			<li>Tại bất kỳ thời điểm nào, Vietjet có quyền đưa ra các mức giá áp dụng (giá bán thực tế) khác với giá gốc của Power Pass mà không cần thông báo trước. Tất cả các mức giá này đều được thể hiện rõ cho từng loại Power Pass hiển thị trên trang Đăng ký và Mua.</li>
			<li>
				Vietjet Air c&oacute; quyền x&aacute;c thực v&agrave; kiểm tra lại
				t&iacute;nh đủ điều kiện mua đối với Power Pass, cũng như
				c&oacute; quyền sửa đổi, điều chỉnh c&aacute;c điều kiện
				n&agrave;y bất cứ l&uacute;c n&agrave;o
			</li>
			<li>
				Tại bất kỳ thời điểm n&agrave;o, Vietjet Air c&oacute; quyền
				x&aacute;c minh t&igrave;nh trạng của người mua, bao gồm
				x&aacute;c minh th&ocirc;ng tin do người mua cung cấp v&agrave;
				y&ecirc;u cầu cung cấp th&ecirc;m th&ocirc;ng tin để đảm bảo rằng
				người mua đ&aacute;p ứng c&aacute;c điều khoản v&agrave; điều kiện
				mua Power Pass.
			</li>
			<li>
				Tại bất kỳ thời điểm n&agrave;o, Vietjet Air cũng c&oacute; quyền
				hủy Power Pass nếu x&aacute;c minh được rằng n&oacute; kh&ocirc;ng
				đ&aacute;p ứng đủ điều kiện hoặc kh&ocirc;ng c&ograve;n hiệu lực.
			</li>
			<li>
				Chủ sở hữu hay người thụ hưởng Power Pass phải th&ocirc;ng
				b&aacute;o kịp thời cho Vietjet Air về bất kỳ việc sử dụng
				tr&aacute;i ph&eacute;p n&agrave;o đối với Power Pass.
			</li>
			<li>
				Trong bất kỳ trường hợp n&agrave;o, tất cả c&aacute;c Power Pass
				đều kh&ocirc;ng được ph&eacute;p ho&agrave;n lại tiền hoặc chuyển
				nhượng.
			</li>
			<li>
				Chủ sở hữu hay người thụ hưởng Power Pass phải sử dụng th&ocirc;ng
				tin đăng nhập đ&atilde; được x&aacute;c nhận để truy cập
				v&agrave;o t&agrave;i khoản Power Pass của m&igrave;nh qua một
				cổng th&ocirc;ng tin được cung cấp. Power Pass kh&ocirc;ng thể sử
				dụng cũng như kh&ocirc;ng thể d&ugrave;ng để thanh to&aacute;n cho
				c&aacute;c đặt chỗ được thực hiện b&ecirc;n ngo&agrave;i cổng
				th&ocirc;ng tin đ&atilde; được cung cấp.
			</li>
		</ol>
	</li>
	<li>
		<strong>Đăng k&yacute; v&agrave; mua Power Pass</strong>
		<ol>
			<li>
				Bất kỳ c&aacute; nh&acirc;n n&agrave;o đủ điều kiện thực hiện
				chuyến bay với Vietjet theo Điều lệ vận chuyển của Vietjet đều
				c&oacute; thể được đăng k&yacute; l&agrave;m người thụ hưởng, chủ
				sở hữu Power Pass tại trang
				<a href="http://powerpassbooking.vietjetair.com"
					>powerpassbooking.vietjetair.com</a
				>
				của Vietjet Air, ho&agrave;n to&agrave;n theo quyết định của người
				mua Power Pass. Power Pass chỉ c&oacute; thể mua trực tuyến với số
				lượng giới hạn.
			</li>
			<li>
				Khi đăng k&yacute; mua Power Pass, người mua phải cung cấp
				th&ocirc;ng tin c&aacute; nh&acirc;n ch&iacute;nh x&aacute;c
				v&agrave; hợp lệ theo y&ecirc;u cầu tại từng thời điểm. Người mua,
				người thụ hưởng v&agrave;/hoặc người sở hữu Power Pass chịu
				ho&agrave;n to&agrave;n tr&aacute;ch nhiệm lưu giữ v&agrave; bảo
				mật th&ocirc;ng tin t&agrave;i khoản Power Pass của m&igrave;nh.
			</li>
			<li>
				Kh&aacute;ch h&agrave;ng c&oacute; thể đăng k&yacute; mua loại
				Power Pass ph&ugrave; hợp v&agrave; thực hiện thanh to&aacute;n
				bằng c&aacute;c loại thẻ t&iacute;n dụng như Visa, Master, JCB,
				v.v. v&agrave; c&aacute;c h&igrave;nh thức thanh to&aacute;n trực
				tuyến kh&aacute;c m&agrave; Vietjet y&ecirc;u cầu tại thời điểm
				thanh to&aacute;n.
			</li>
			<li>
				Kh&aacute;ch h&agrave;ng cần chọn loại Power Pass m&agrave;
				m&igrave;nh th&iacute;ch v&agrave; ho&agrave;n tất đăng k&yacute;
				mua.
			</li>
			<li>
				Sau khi đăng k&yacute; mua v&agrave; thanh to&aacute;n
				th&agrave;nh c&ocirc;ng, ch&uacute;ng t&ocirc;i sẽ gửi th&ocirc;ng
				b&aacute;o x&aacute;c nhận (bao gồm th&ocirc;ng tin đăng nhập
				t&agrave;i khoản Power Pass v&agrave; m&atilde; số của loại Power
				Pass đ&atilde; mua) đến địa chỉ email m&agrave; kh&aacute;ch
				h&agrave;ng đ&atilde; đăng k&yacute;. Đề nghị Qu&yacute;
				kh&aacute;ch h&agrave;ng kiểm tra thư mục thư r&aacute;c trong hộp
				thư điện thử để chắc chắn nhận được email x&aacute;c nh&acirc;n.
			</li>
		</ol>
	</li>
	<li>
		<strong>Đặt v&eacute; với Power Pass</strong>

		<ol>
			<li>
				Người thụ hưởng hay chủ sở hữu của Power Pass phải truy cập
				v&agrave;o trang
				<a href="https://powerpassbooking.vietjetair.com/"
					>https://powerpassbooking.vietjetair.com/</a
				>v&agrave; sử dụng t&ecirc;n v&agrave; mật khẩu đ&atilde; đăng
				k&yacute; cho t&agrave;i khoản Power Pass của m&igrave;nh để đăng
				nhập.
			</li>
			<li>
				Mỗi Power Pass chỉ c&oacute; thể sử dụng để đặt chuyến bay cho
				ch&iacute;nh người thụ hưởng Power Pass đ&oacute;, ngoại trừ em
				b&eacute; dưới 2 tuổi đi c&ugrave;ng. Nếu h&agrave;nh kh&aacute;ch
				đi c&ugrave;ng với em b&eacute; dưới 2 tuổi hoặc với người
				kh&aacute;c, xin vui l&ograve;ng li&ecirc;n hệ với Trung t&acirc;m
				dịch vụ kh&aacute;ch h&agrave;ng của ch&uacute;ng t&ocirc;i để
				được trợ gi&uacute;p.
			</li>
			<li>
				Việc đặt v&eacute; v&agrave; đi lại phải tu&acirc;n theo tất cả
				c&aacute;c quy tắc, ch&iacute;nh s&aacute;ch, điều khoản v&agrave;
				Điều lệ vận chuyển hiện h&agrave;nh của Vietjet, v&agrave;
				c&aacute;c quy định của nh&agrave; chức tr&aacute;ch li&ecirc;n
				quan. Đối với c&aacute;c dịch vụ đặc biệt
				<em
					>(v&iacute; dụ: trẻ vị th&agrave;nh ni&ecirc;n đi một
					m&igrave;nh, kh&aacute;ch h&agrave;ng c&oacute; nhu cầu đặc
					biệt, đi c&ugrave;ng trẻ sơ sinh hay trẻ nhỏ dưới 2 tuổi,
					kh&aacute;ch h&agrave;ng mang vật nu&ocirc;i hay th&uacute; cưng
					đi c&ugrave;ng)</em
				>
				phải tu&acirc;n theo c&aacute;c điều kiện v&agrave; hạn chế.
			</li>
			<li>
				Chuyến bay phải được đặt chỗ v&agrave; ho&agrave;n tất thanh
				to&aacute;n &iacute;t nhất 72 giờ trước giờ khởi h&agrave;nh.
			</li>
			<li>
				T&ecirc;n h&agrave;nh kh&aacute;ch, ng&agrave;y sinh, th&ocirc;ng
				tin giấy tờ t&ugrave;y th&acirc;n
				<em
					>(v&iacute; dụ CMND, Căn cước c&ocirc;ng d&acirc;n, Hộ chiếu,
					v.v.)</em
				>
				phải tr&ugrave;ng khớp ch&iacute;nh x&aacute;c với th&ocirc;ng tin
				đ&atilde; đăng k&yacute; trong t&agrave;i khoản Power Pass.
			</li>
			<li>
				M&atilde; số Power Pass sẽ được sử dụng để thanh to&aacute;n tiền
				gi&aacute; v&eacute; cơ bản của c&aacute;c chuyến bay cho
				h&agrave;nh kh&aacute;ch (người thụ hưởng hay người sở hữu).
				H&agrave;nh kh&aacute;ch phải tự thanh to&aacute;n tiền thuế,
				ph&iacute; &aacute;p dụng v&agrave; c&aacute;c dịch vụ bổ sung
				được mua c&ugrave;ng với chuyến bay đ&atilde; đặt (trong hoặc sau
				khi đặt chỗ ban đầu) bằng c&aacute;c h&igrave;nh thức thanh
				to&aacute;n trực tuyến m&agrave; Vietjet y&ecirc;u cầu v&agrave;
				chấp nhận.
			</li>
			<li>
				C&aacute;c chuyến bay được đặt th&ocirc;ng qua t&agrave;i khoản
				Power Pass v&agrave; thanh to&aacute;n tiền v&eacute; m&aacute;y
				bay bằng Power Pass sẽ kh&ocirc;ng được ph&eacute;p để chờ hoặc
				thanh to&aacute;n sau.
			</li>
			<li>
				T&ugrave;y theo y&ecirc;u cầu của nh&agrave; chức tr&aacute;ch
				hoặc v&igrave; l&yacute; do thương mại hoặc l&yacute; do khai
				th&aacute;c, c&oacute; thể c&oacute; một số chuyến bay kh&ocirc;ng
				thể đặt được chỗ th&ocirc;ng qua t&agrave;i khoản th&agrave;nh
				vi&ecirc;n Power Pass.
			</li>
		</ol>
		<ol start="9">
			<li>
				Việc đặt chuyến bay của người thụ hưởng Power Pass sẽ phụ thuộc
				v&agrave;o t&igrave;nh trạng chỗ của chuyến bay. Số chỗ c&oacute;
				thể bị hạn chế khi h&agrave;nh kh&aacute;ch đặt chỗ v&agrave;o
				thời điểm s&aacute;t ng&agrave;y khởi h&agrave;nh v&agrave; trong
				c&aacute;c giai đoạn cao điểm. V&igrave; l&yacute; do n&agrave;y,
				kh&aacute;ch kh&aacute;ch n&ecirc;n đặt v&agrave; x&aacute;c nhận
				c&aacute;c chuyến bay c&agrave;ng sớm c&agrave;ng tốt.
			</li>
			<li>
			  Không được đặt chỗ trên các chuyến bay trong giai đoạn Tết Nguyên Đán (từ ngày 09/02/2021 đến hết ngày 28/02/2021).
			</li>
			<li>
				Chuyến bay phải được đặt chỗ v&agrave; ho&agrave;n th&agrave;nh
				trong thời gian hiệu lực của Power Pass, v&agrave; kh&ocirc;ng
				được ph&eacute;p gia hạn.
			</li>
			<li>
				C&aacute;c chuyến bay v&agrave; chặng bay c&oacute; thể theo
				m&ugrave;a vụ v&agrave; thay đổi bất cứ l&uacute;c n&agrave;o
				m&agrave; kh&ocirc;ng c&oacute; th&ocirc;ng b&aacute;o trước;
				c&aacute;c chuyến bay v&agrave; chặng bay cũng c&oacute; thể được
				khai th&aacute;c với tần suất hạn chế.
			</li>
			<li>
				Việc đặt v&eacute; v&agrave; đi lại phải tu&acirc;n theo tất cả
				c&aacute;c quy định, ch&iacute;nh s&aacute;ch, điều khoản
				v&agrave; điều kiện vận chuyển, điều kiện v&eacute; của Vietjet
				Air hiện h&agrave;nh. Đối với c&aacute;c dịch vụ đặc biệt
				<em
					>(v&iacute; dụ: trẻ vị th&agrave;nh ni&ecirc;n kh&ocirc;ng
					c&oacute; người đi k&egrave;m, kh&aacute;ch h&agrave;ng
					c&oacute; nhu cầu đặc biệt, đi c&ugrave;ng trẻ sơ sinh hay trẻ
					nhỏ dưới 2 tuổi, đi du lịch với th&uacute; cưng)</em
				>
				phải tu&acirc;n theo c&aacute;c điều kiện v&agrave; hạn chế; Nhấn
				<a
					href="https://www.vietjetair.com/Sites/Web/vi-VN/NewsDetail/dich-vu-dac-biet/%201396/dich-vu-dac-biet"
					>v&agrave;o đ&acirc;y</a
				>
				để c&oacute; th&ecirc;m th&ocirc;ng tin.
			</li>
			<li>
				Tại bất kỳ thời điểm n&agrave;o, Vietjet Air c&oacute; to&agrave;n
				quyền hủy bỏ tư c&aacute;ch th&agrave;nh vi&ecirc;n của Power Pass
				v&agrave; tất cả c&aacute;c hồ sơ đặt chuyến bay li&ecirc;n quan,
				nếu như x&aacute;c minh đươc rằng việc mua Power Pass kh&ocirc;ng
				đ&aacute;p ứng Điều khoản v&agrave; Điều kiện của chương
				tr&igrave;nh, bao gồm lạm dụng c&aacute;c ưu đ&atilde;i hoặc cung
				cấp hay diễn giải sai bất kỳ th&ocirc;ng tin cho Vietjet.
			</li>
		</ol>
	</li>
	<li>
		<strong
			>Điều kiện gi&aacute; v&eacute; được đặt v&agrave; c&oacute;
			h&igrave;nh thức thanh to&aacute;n bằng Power Pass</strong
		>
		<ol>
			<li>
				Người thụ hưởng Power Pass c&oacute; thể đặt chỗ th&ocirc;ng qua
				t&agrave;i khoản th&agrave;nh vi&ecirc;n Power Pass của
				m&igrave;nh v&agrave; sử dụng Power Pass như một h&igrave;nh thức
				thanh to&aacute;n để mua v&eacute; bay kh&ocirc;ng giới hạn về
				chặng bay v&agrave; số lần bay tr&ecirc;n tất cả c&aacute;c chuyến
				bay thường lệ nội địa Việt Nam do Vietjet khai th&aacute;c.
			</li>
			<li>
				Hiệu lực của Power Pass v&agrave; c&aacute;c chuyến bay được đặt
				chỗ sẽ phải tuân theo các điều kiện cụ thể được công bố và áp dụng cho từng loại Power Pass.
			</li>
			<li>
				Miễn 100% tiền gi&aacute; v&eacute; được thanh to&aacute;n bằng
				Power Pass
			</li>
			<li>
				Kh&aacute;ch h&agrave;ng được hưởng miễn ph&iacute; ti&ecirc;u
				chuẩn 15kg h&agrave;nh l&yacute; k&yacute; gửi v&agrave; 07 kg
				h&agrave;nh l&yacute; x&aacute;ch tay.
			</li>
			<li>
				Người thụ hưởng Power Pass phải thanh to&aacute;n tiền thuế,
				ph&iacute; &aacute;p dụng v&agrave; c&aacute;c dịch vụ bổ sung
				được mua c&ugrave;ng với chuyến bay đ&atilde; đặt (trong hoặc sau
				khi đặt chỗ ban đầu) ngay tại thời điểm đặt chỗ th&ocirc;ng qua
				c&aacute;c h&igrave;nh thức thanh to&aacute;n trực tuyến m&agrave;
				Vietjet y&ecirc;u cầu v&agrave; chấp nhận.
			</li>
			<li>
				Việc đặt chỗ v&agrave; thanh to&aacute;n cho chuyến bay phải được
				thực hiện &iacute;t nhất 72 giờ trước giờ khởi h&agrave;nh.
			</li>
			<li>
				Được ph&eacute;p thay đổi ng&agrave;y bay, chuyến bay. Ph&iacute;
				thay đổi l&agrave; 100,000VND/kh&aacute;ch/thay đổi (chưa bao gồm
				thuế VAT).
			</li>
			<li>
				C&aacute;c thay đổi phải được thực hiện trước 03 giờ so với giờ
				khởi h&agrave;nh đ&atilde; đặt, v&agrave; giờ khởi h&agrave;nh mới
				phải sau giờ khởi h&agrave;nh ban đầu tối thiểu l&agrave; 72 giờ.
				To&agrave;n bộ tiền gi&aacute; v&eacute;, thuế, c&aacute;c loại
				ph&iacute; v&agrave; tiền trả cho c&aacute;c sản phẩm dịch vụ
				k&egrave;m chuyến bay đ&atilde; mua sẽ bị mất khi kh&aacute;ch
				h&agrave;ng đổi v&eacute; sau thời hạn tr&ecirc;n hoặc bỏ chỗ
				(no-show).
			</li>
			<li>
				C&aacute;c thay đổi phải được thực hiện trực tuyến tr&ecirc;n
				trang www.<a href="http://www.vietjetair.com">vietjetair.com</a>.
				C&aacute;c y&ecirc;u cầu thay đổi c&oacute; thể được thực hiện qua
				Tổng đ&agrave;i phục vụ kh&aacute;ch h&agrave;ng hoặc tại Quầy
				v&eacute; tại s&acirc;n bay của Vietjet với khoản ph&iacute;
				&aacute;p dụng theo quy định hiện h&agrave;nh của Vietjet.
			</li>
			<li>
				V&eacute; kh&ocirc;ng được ph&eacute;p đổi t&ecirc;n trong bất kỳ
				trường hợp n&agrave;o.
			</li>
			<li>
				To&agrave;n bộ tiền v&eacute;, thuế, c&aacute;c loại ph&iacute;
				v&agrave; tiền trả cho c&aacute;c sản phẩm dịch vụ k&egrave;m
				chuyến bay đ&atilde; mua kh&ocirc;ng được ph&eacute;p ho&agrave;n
				trả.
			</li>
		</ol>
	</li>
	<li>
		<strong>Quyền ri&ecirc;ng tư</strong>

		<p>
			Vietjet Air ho&agrave;n to&agrave;n t&ocirc;n trọng quyền
			ri&ecirc;ng tư của chủ sở hữu Power Pass. Qu&yacute; kh&aacute;ch
			c&oacute; thể t&igrave;m thấy ch&iacute;nh s&aacute;ch hiện
			h&agrave;nh về quyền ri&ecirc;ng tư tại trang chủ
			<a href="http://www.vietjetair.com">www.vietjetair.com</a>. Xem
			Ch&iacute;nh s&aacute;ch về quyền ri&ecirc;ng tư
			<a
				href="https://www.vietjetair.com/Sites/Web/vi-VN/NewsDetail/chinh-sach-bao-mat/%201305/chinh-sach-bao-mat"
				>tại đ&acirc;y</a
			>.
		</p>
	</li>
	<li>
		<strong>Tr&aacute;ch nhiệm ph&aacute;p l&yacute;</strong>

		<ol>
			<li>
				Vietjet Air kh&ocirc;ng chịu tr&aacute;ch nhiệm cho bất kỳ tổn
				thất hoặc khiếu nại n&agrave;o ph&aacute;t sinh từ việc
				kh&aacute;ch h&agrave;ng kh&ocirc;ng thể truy cập v&agrave;o trang
				chủ của Vietjet, hoặc từ việc kh&aacute;ch h&agrave;ng kh&ocirc;ng
				thể ho&agrave;n th&agrave;nh một giao dịch n&agrave;o đ&oacute;.
			</li>
			<li>
				Ngo&agrave;i những quy định r&otilde; r&agrave;ng trong Điều kiện
				v&agrave; Điều khoản &aacute;p dụng n&agrave;y, Vietjet Air sẽ
				kh&ocirc;ng chịu tr&aacute;ch nhiệm cho bất kỳ tổn thất, chi
				ph&iacute; hoặc thiệt hại n&agrave;o (d&ugrave; trực tiếp hay
				gi&aacute;n tiếp) bắt nguồn từ sự tr&ocirc;ng cậy của người thụ
				hưởng hay chủ sở hữu của Power Pass đối với c&aacute;c th&ocirc;ng
				tin v&agrave; gợi &yacute; li&ecirc;n quan từ Vietjet Air
				v&agrave; từ việc cung cấp h&agrave;ng h&oacute;a v&agrave; dịch
				vụ của bất kỳ b&ecirc;n thứ ba n&agrave;o cung cấp cho người thụ
				hưởng hay chủ sở hữu Power Pass.
			</li>
			<li>
				Vietjet Air sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm về việc thất
				lạc, gửi nhầm, bị trả lại hoặc cung cấp trễ th&ocirc;ng tin
				b&aacute;n h&agrave;ng được gửi qua email.
			</li>
			<li>
				Trong mọi trường hợp, nghĩa vụ ph&aacute;p l&yacute; của Vietjet
				Air sẽ kh&ocirc;ng vượt qu&aacute; gi&aacute; trị của Power Pass
				đối với người thụ hưởng hay chủ sở hữu của Power Pass, v&agrave;
				cũng trong bất kỳ t&igrave;nh huống n&agrave;o th&igrave; Vietjet
				Air sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm cho c&aacute;c thiệt
				hại ph&aacute;t sinh v&agrave; hậu quả li&ecirc;n đới tiếp theo
				của người thụ hưởng hay chủ sở hữu Power Pass.
			</li>
			<li>
				Vietjet Air đặt mục ti&ecirc;u đảm bảo rằng virus (hoặc c&aacute;c
				chương tr&igrave;nh kh&aacute;c c&oacute; t&aacute;c động bất lợi)
				sẽ kh&ocirc;ng c&oacute; tr&ecirc;n trang web, nhưng Vietjet Air
				kh&ocirc;ng chịu tr&aacute;ch nhiệm đối với bất kỳ virus hoặc
				m&atilde; độc n&agrave;o kh&aacute;c m&agrave; người thụ hưởng hay
				chủ sở hữu Power Pass c&oacute; thể nhiễm từ việc sử dụng trang
				web hoặc từ bất kỳ trang web của nh&agrave; cung cấp web
				kh&aacute;c.
			</li>
		</ol>
		<p>
			Phần n&agrave;y chỉ &aacute;p dụng trong phạm vi được ph&aacute;p
			luật cho ph&eacute;p.
		</p>
	</li>

	<li>
		<strong>Bản quyền v&agrave; thương hiệu</strong>
		<ol>
			<li>
				Vietjet Air sở hữu hoặc c&oacute; quyền hợp ph&aacute;p đối với
				tất cả c&aacute;c t&agrave;i liệu trong trang web n&agrave;y. Tất
				cả c&aacute;c bản quyền v&agrave; sở hữu tr&iacute; tuệ
				kh&aacute;c đ&atilde; được đăng k&yacute; bảo hộ. Trang web
				n&agrave;y chỉ d&agrave;nh cho mục đ&iacute;ch c&aacute;
				nh&acirc;n v&agrave; kh&ocirc;ng được sử dụng cho mục đ&iacute;ch
				thương mại. Người thụ hưởng hay chủ sở hữu Power Pass chỉ
				c&oacute; thể tải xuống m&aacute;y t&iacute;nh c&aacute;
				nh&acirc;n của m&igrave;nh để xem mục đ&iacute;ch v&agrave; in ra
				một số trang của trang web n&agrave;y để sử dụng cho mục
				đ&iacute;ch c&aacute; nh&acirc;n. Người thụ hưởng hay chủ sở hữu
				Power Pass kh&ocirc;ng được sửa đổi, sao ch&eacute;p, ph&acirc;n
				phối, ph&aacute;t t&aacute;n, hiển thị, thực hiện, t&aacute;i tạo,
				xuất bản, cấp ph&eacute;p, tạo c&aacute;c t&aacute;c phẩm
				ph&aacute;i sinh, chuyển nhượng hoặc b&aacute;n bất kỳ th&ocirc;ng
				tin n&agrave;o c&oacute; được từ trang web n&agrave;y.
			</li>
			<li>
				Tất cả c&aacute;c nh&atilde;n hiệu, t&ecirc;n sản phẩm, t&ecirc;n
				c&ocirc;ng ty v&agrave; logo xuất hiện tr&ecirc;n trang web
				n&agrave;y l&agrave; t&agrave;i sản của chủ sở hữu li&ecirc;n
				quan.
			</li>
		</ol>
	</li>
	<li>
		<strong>Điều khoản kh&aacute;c</strong>
		<ol>
			<li>
				Người thụ hưởng hay chủ sở hữu Power Pass đồng &yacute; rằng
				kh&ocirc;ng c&oacute; mối quan hệ li&ecirc;n doanh, hợp
				t&aacute;c, quan hệ việc l&agrave;m hoặc quan hệ đại l&yacute;
				n&agrave;o tồn tại giữa người thụ hưởng hay chủ sở hữu Power Pass
				v&agrave; Vietjet Air xuất ph&aacute;t từ Điều kiện v&agrave; Điều
				khoản &aacute;p dụng n&agrave;y hoặc từ việc sử dụng trang web
				n&agrave;y.
			</li>
			<li>
				Nếu Qu&yacute; kh&aacute;ch c&oacute; bất kỳ c&acirc;u hỏi hoặc
				&yacute; kiến, xin vui l&ograve;ng li&ecirc;n hệ với ch&uacute;ng
				t&ocirc;i tại + 84-1900-1886.
			</li>
		</ol>
	</li>
</ol>
<p>
	<strong><em>Vietjet Air JSC</em></strong>
</p>
</div>`) 
} </>)
	}else {
		return (<> { ReactHtmlParser (`<div>
		<h1><strong>Vietjet POWER PASS</strong> – Terms and Conditions</h1>
		<p>Once Customer chooses to check the box <strong><i>“I accept the terms & conditions*”</i></strong> during your registration and purchase of Power Pass, this means that Customer chooses to accept and agree on all regulations, conditions, applications, disclaimers as stated below. It is required Customer to carefully read this Terms and Conditions before proceeding payment!</p>
		<ol>
			<li>
				<strong>General terms</strong>
				<ol>
					<li>
						Power Pass is a form of payment used by only an individual
						consumer whose name and personal details exactly match with the
						details registered with Vietjet for such specific Power Pass.
						Subject to terms and conditions of Power Pass, and to the
						eligibility and application of each Power Pass type, the customer
						(beneficiary or owner of the pass) can use the pass to pay base
						fare of any Vietjet&rsquo;s Vietnam domestic flights for unlimited
						travels within validity and eligibility in relation to the Power
						Pass.
					</li>
					<li>
						The Power Pass is good for any purchase by eligible payments
						methods offered by Vietjet Air.
					</li>
					<li> Vietjet Air reserves the right, at any time and without prior notice, to determine and publish applicable price of Power Pass for sale (price to pay for POWER PASS) which can be different from an original price of POWER PASS. All those prices are clearly stated in each type of Power Pass displayed on the Register and Purchase page.</li>
					<li>
						Vietjet Air reserves the right at any time to determine and
						re-examine the purchase eligibility, as well as the right to
						modify or otherwise amend the eligibility requirements.
					</li>
					<li>
						Vietjet Air reserves the right, at any time, to verify the status
						of the purchaser, including the verification of information
						provided by the purchase and making a request for additional
						information to ensure that the purchaser meets the Power Pass
						purchase terms and conditions.
					</li>
					<li>
						Vietjet Air also reserves the right, at any time, to cancel the
						Power Pass should it determine that the eligibility criteria have
						not been met or are no longer valid.
					</li>
					<li>
						The Power Pass&rsquo; beneficiary or owner must promptly notify
						Vietjet Air upon becoming aware of any unauthorized use of the
						Power Pass.
					</li>
					<li>
						Power Pass is non-refundable, neither transferable in any case.
					</li>
					<li>
						Power Pass&rsquo; beneficiary or owner will have access to a
						dedicated portal by using their login credentials provided in the
						email confirmation. The Power Pass is not available and will not
						apply to bookings created outside the dedicated portal.
					</li>
				</ol>
			</li>

			<li>
				<strong>Register and Purchase of Power Pass</strong>
				<ol>
					<li>
						Any individual, who is eligible to fly with Vietjet subject to its
						Condition of Carriage, may be registered as beneficiary or owner
						of Power Pass at Vietjet Air website at
						<a href="http://powerpassbooking.vietjetair.com"
							>powerpassbooking.vietjetair.com</a
						>
						at the discretion of the purchaser. Power Pass is available for
						purchase on a limited online offer only.
					</li>
					<li>
						The purchasing individual must exactly provide valid and accurate
						personal information as required from time to time in order to
						purchase the Power Pass. The purchaser is fully responsible for
						keeping details of the Power Pass confidentially.
					</li>
					<li>
						The purchasing individual can register to purchase a preferred
						Power Pass type and pay by credit cards such as Visa, Master, JCB,
						etc. and other available forms of payment we offer online at the
						time of your payment.
					</li>
					<li>
						Select your preferred Power Pass type and complete the
						registration of purchase
					</li>
				</ol>
				<ol start="5">
					<li>
						Upon successful purchase, an email confirmation with your Power
						Pass account details and Power Pass ID number will be sent to your
						designated email address. Please also check Junk Email or Spam
						folder of your designated email account to ensure you receive
						confirmation email.
					</li>
				</ol>
			</li>
			<li>
				<strong>Booking of flights by Power Pass</strong>
				<ol>
					<li>
						Beneficiary or owner of Power Pass must login&nbsp;<a
							href="https://powerpassbooking.vietjetair.com/"
							>https://powerpassbooking.vietjetair.com/</a
						>
						with username and password registered at the Register and Purchase
						to book flights.
					</li>
					<li>
						Only one Power Pass may be used for booking flight for the
						beneficiary of such Power Pass, except for companied infants under
						2 years old. If traveling with an infant under 2 years old or
						other paying companion, please contact our Call Center for
						support.
					</li>
					<li>
						All bookings and travels must comply with current policies,
						procedures, conditions of carriage of Vietjet, and with
						regulations of relevant authorities. Passengers having special
						service requirements (unaccompanied minors, special assistance
						needs, infant under 2 years old, accompanied pets) must be subject
						to applicable conditions and restrictions.
					</li>
					<li>
						Flight bookings must be made at least 72 hours prior departure
						time.
					</li>
					<li>
						Passenger Name, Date of birth, information of personal
						identification document (national ID card, passport, etc.) must
						exactly match the details already registered under Power Pass
						member account.
					</li>
					<li>
						Your Power Pass ID Number will be applied as "payment" towards the
						base fare of Vietjet Air operated flights only. Member must pay by
						available payment methods offered by Vietjet for the taxes,
						applicable fees and additional services, ancillary being purchased
						together with the booked flight (during or after the original
						booking).
					</li>
					<li>
						Hold booking and/or pay later as form of payment are not permitted
						for booking flights through Power Pass member account.
					</li>
					<li>
						Subject to regulatory requirement or commercial and operational
						reasons, not all flights may be eligible to book through Power
						Pass member account.
					</li>
					<li>
						Flight bookings for all Power Pass beneficiary are subject to
						availability. Space may be limited for bookings made close to the
						departure date and during peak travel periods. For this reason it
						is recommended that you book and confirm flights as far in advance
						of travel as possible.
					</li>
					<li>
					Booking of flights is not permitted during Lunar New Year period (from 09/02/2021 to 28/02/2021).
					</li>
					<li>
						Travel must be booked and completed within the validity period of
						the Power Pass. No extensions permitted.
					</li>
					<li>
						Flights and routes may be seasonal and are subject to change
						without notice at any time; flights and routes might also operate
						on a limited frequency.
					</li>
					<li>
						The booking and travel are subject to all applicable Vietjet Air
						rules, policies, terms and conditions of carriage and tariffs. For
						special services (e.g. unaccompanied minors, customers with
						special needs, travelling with an infant under 2 years old,
						travelling with a pet) is subject to conditions and restrictions;
						click&nbsp;<a
							href="https://www.vietjetair.com/Sites/Web/en-US/NewsDetail/special-services/1397/special-services--vietjetvj"
							>here</a
						>for more information.
					</li>
					<li>
						Vietjet Air reserves the right at anytime on its own discretion to
						cancel the Power Pass membership and all related flight bookings
						if it should determine that the purchase of the Power Pass does
						not meet the program Terms and Conditions, including abuse of
						privileges, or misrepresentation of any information provided to
						Vietjet Air).
					</li>
				</ol>
			</li>
			<li>
				<strong
					>Fare rules for ticket booked and paid by Power Pass as a form of
					payment</strong>
				<ol>
					<li>
						Power Pass beneficiary can make a booking book through Power Pass
						account and use designated Power Pass as a form of payment to
						purchase tickets for unlimited travels on all Vietnam domestic
						regular flights operated by Vietjet.
					</li>
					<li>Validity of Power Pass for booking and eligible travels are subject to specific conditions published and applied to each type of Power Pass.</li>
					<li>
						Base fare of ticket paid by Power Pass as a form of payment is
						100% free of charge.
					</li>
					<li>
						15kg check baggage and 7 kg carry-on baggage allowances per
						passenger per flight are included.
					</li>
					<li>
						All taxes, applicable fees and additional services, ancillary
						being purchased together with the booked flight (during or after
						the original booking) must be paid by Power Pass beneficiary
						immediately at the time of booking through available payment
						methods offered by Vietjet.
					</li>
					<li>
						Flight bookings must be made at least 72 hours prior departure
						time.
					</li>
					<li>
						Date change and reroute are both permitted at a fee of 100,000VND
						(excluding VAT) per passenger per change.
					</li>
					<li>
						Changes must be made at least 3 hours before scheduled departure
						time, and new departure time must be at least 72 hours after
						original departure time. All fare, taxes, applicable fees and
						additional services, ancillary purchased will be forfeited if
						changes are made within 3 hours prior departure time or if
						passenger is not shown.
					</li>
					<li>
						All changes must be completed online in the self-serve via www.<a
							href="http://www.vietjetair.com"
							>vietjetair.com</a
						>. Changes may be made via Vietjet Call Center or at Vietjet
						Airport Ticketing Offices with a fee subject to the Vietjet fees
						and charges policy.
					</li>
					<li>Change of name is not permitted in any circumstances.</li>
					<li>
						All fare, taxes, applicable fees and additional services,
						ancillary purchased are non-refundable.
					</li>
				</ol>
			</li>
			<li>
				<strong>Privacy</strong>

				<p>
					Vietjet Air is respectful of each Power Pass holder's privacy. You
					can find out our current privacy policy at our website
					www.vietjetair.com. View the full privacy policy
					<a
						href="https://www.vietjetair.com/Sites/Web/en-US/NewsDetail/vietjet-privacy-policy/%203266/privacy-policy"
						>here</a
					>.
				</p>
			</li>

			<li>
				<strong>Liability</strong>

				<ol>
					<li>
						Vietjet Air accepts no liability for any losses or claims arising
						from any inability to access the Site or any failure to complete a
						transaction.
					</li>
					<li>
						Except as expressly provided for in this Agreement, Vietjet Air
						shall not be liable for any loss, cost, expense or damage of any
						nature (whether direct or indirect), resulting from a Power Pass
						holder's reliance upon the information and suggestions provided by
						Vietjet Air hereunder and the resulting supply of goods and
						services to a Power Pass&rsquo;s holder by any third party.
					</li>
					<li>
						Vietjet Air will not be responsible for lost, misdirected,
						bounced, or late delivery of sale information delivered via email.
					</li>
					<li>
						Under no circumstances shall Vietjet Air's liability exceed any
						Power Pass holder's current Power Pass fee and under no
						circumstances shall Vietjet Air be liable for a Power Pass
						holder's incidental or consequential damages.
					</li>
					<li>
						Vietjet Air aims to ensure that viruses (or other programs having
						adverse effects) do not reside on the Site, but Vietjet Air
						accepts no responsibility for any virus or other malicious code
						that a Power Pass holder may acquire from the use of the Site or
						from any supplier site.
					</li>
				</ol>
				<p>This section applies only to the extent permitted by law.</p>
				<p></p>
			</li>
			<li>
				<strong>Copyright and Trademarks</strong>

				<ol>
					<li>
						Vietjet Air owns or is lawfully entitled to all of the copyrighted
						material in this web site. All other intellectual property rights
						are reserved. This web site is for personal use only and may not
						be used for commercial purposes. A Power Pass holder may only
						download to his or her personal computer for viewing purposes and
						print out a number of pages of this web site for the Power Pass
						holder's personal use. Power Pass holder may not modify, copy,
						distribute, transmit, display, perform, reproduce, publish,
						license, create derivative works from, transfer or sell any
						information obtained from this web site.
					</li>
				</ol>
				<ol start="2">
					<li>
						All trademarks, product names, and company names and logos
						appearing on this web site are the property of their respective
						owners.
					</li>
				</ol>
			</li>
			<li>
				<strong>Miscellaneous</strong>
				<ol>
					<li>
						Power Pass holder agrees that no joint venture, partnership,
						employment, or agency relationship exists between Power Pass
						holder and Vietjet Air as a result of this Agreement or use of
						this web site.
					</li>
					<li>
						If you have any questions or comments, please contact us at +
						84-1900-1886<em>.</em>
					</li>
				</ol>
			</li>
		</ol>
		<p><strong>Vietjet Air JSC</strong></p>
	</div>`)}</>)
	}
};